import { render, staticRenderFns } from "./SlotEditor.vue?vue&type=template&id=00298531"
import script from "./SlotEditor.vue?vue&type=script&lang=js"
export * from "./SlotEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports